var theme = require('./theme')
var flatten = require('./flatten')

module.exports = theme('en_US', flatten(require('./source/en_US')))
